"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubHeader = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var button_1 = require("../../../elements/button/button");
var button_type_1 = require("../../../elements/button/button-type");
var tab_panel_menu_1 = require("../../tab-panel-menu/tab-panel-menu");
var header_menu_type_1 = require("../menu/header-menu-type");
var sub_header_style_1 = require("./sub-header-style");
function SubHeader(props) {
    var subHeaderItems = props.subHeaderItems, _a = props.subHeaderType, subHeaderType = _a === void 0 ? header_menu_type_1.SubHeaderType.TAB_PANEL : _a, activeItemIndex = props.activeItemIndex, onSubItemClick = props.onSubItemClick;
    function innerSubHeader() {
        if (subHeaderType === header_menu_type_1.SubHeaderType.TITLE_BUTTON) {
            var _a = subHeaderItems, title = _a.title, buttons = _a.buttons;
            return ((0, jsx_runtime_1.jsxs)(sub_header_style_1.StyledTitleButtonItem, { children: [(0, jsx_runtime_1.jsx)(sub_header_style_1.StyledTitleButtonItemTitle, { children: title }), buttons.map(function (buttonProps, index) {
                        return (0, react_1.createElement)(button_1.Button, __assign({}, buttonProps, { size: button_type_1.ButtonSize.X_SMALL, key: index }));
                    })] }));
        }
        return ((0, jsx_runtime_1.jsx)(tab_panel_menu_1.TabPanelMenu, { tabs: subHeaderItems, activeIndex: activeItemIndex, onTabClick: function (tabIndex) {
                onSubItemClick === null || onSubItemClick === void 0 ? void 0 : onSubItemClick(tabIndex);
            } }));
    }
    return (0, jsx_runtime_1.jsx)(sub_header_style_1.StyledSubHeader, { children: subHeaderItems ? innerSubHeader() : null });
}
exports.SubHeader = SubHeader;
